/**
 * @generated SignedSource<<459c1c875bdb1a5956db5421573053ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GetAssetAllocationInput = {
  financialAccountIds: ReadonlyArray<number>;
};
export type GetAssetAllocationModelFilterInput = {
  accountBalance?: ComparableDecimalOperationFilterInput | null;
  accountDefaultName?: StringOperationFilterInput | null;
  accountId?: ComparableInt32OperationFilterInput | null;
  accountNumber?: StringOperationFilterInput | null;
  allocationId?: ComparableInt32OperationFilterInput | null;
  and?: ReadonlyArray<GetAssetAllocationModelFilterInput> | null;
  asOfDate?: ComparableNullableOfDateTimeOperationFilterInput | null;
  assetClass?: StringOperationFilterInput | null;
  assetClassBalance?: ComparableDecimalOperationFilterInput | null;
  managementStyle?: StringOperationFilterInput | null;
  or?: ReadonlyArray<GetAssetAllocationModelFilterInput> | null;
  subAssetClass?: StringOperationFilterInput | null;
  subAssetClassBalance?: ComparableDecimalOperationFilterInput | null;
};
export type ComparableInt32OperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type StringOperationFilterInput = {
  and?: ReadonlyArray<StringOperationFilterInput> | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nstartsWith?: string | null;
  or?: ReadonlyArray<StringOperationFilterInput> | null;
  startsWith?: string | null;
};
export type ComparableDecimalOperationFilterInput = {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: ReadonlyArray<any> | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: ReadonlyArray<any> | null;
  nlt?: any | null;
  nlte?: any | null;
};
export type ComparableNullableOfDateTimeOperationFilterInput = {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: ReadonlyArray<any | null> | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: ReadonlyArray<any | null> | null;
  nlt?: any | null;
  nlte?: any | null;
};
export type GetAccountBalancesInput = {
  financialAccountIds: ReadonlyArray<number>;
};
export type AssetAllocationDetailQueryReaderQuery$variables = {
  assetAllocationFilterInput?: GetAssetAllocationModelFilterInput | null;
  assetAllocationInput: GetAssetAllocationInput;
  balancesInput: GetAccountBalancesInput;
};
export type AssetAllocationDetailQueryReaderQuery$data = {
  readonly clientsummary_viewer: {
    readonly financialAccounts: ReadonlyArray<{
      readonly accountName: string;
      readonly accountNumber: string;
      readonly accountType: string;
      readonly accountTypeAbbreviation: string;
      readonly clientIdentifier: any;
      readonly custodian: string;
      readonly id: string;
      readonly managementStyle: string;
      readonly registrationName: string;
    }>;
    readonly getAccountBalances: ReadonlyArray<{
      readonly accountId: number;
      readonly totalBalance: any;
    }>;
    readonly getAssetAllocations: ReadonlyArray<{
      readonly accountBalance: any;
      readonly accountDefaultName: string;
      readonly accountId: number;
      readonly accountNumber: string;
      readonly allocationId: number;
      readonly asOfDate: any | null;
      readonly assetClass: string;
      readonly assetClassBalance: any;
      readonly managementStyle: string;
      readonly subAssetClass: string;
      readonly subAssetClassBalance: any;
    }>;
    readonly id: string;
  };
  readonly userprofile_viewer: {
    readonly accountGroups: ReadonlyArray<{
      readonly accounts: ReadonlyArray<{
        readonly financialAccountId: number;
        readonly id: any;
      }>;
      readonly id: string;
      readonly name: string;
    }>;
    readonly accounts: ReadonlyArray<{
      readonly accountNickname: string;
      readonly financialAccountId: number;
    }>;
    readonly id: string;
  } | null;
};
export type AssetAllocationDetailQueryReaderQuery = {
  response: AssetAllocationDetailQueryReaderQuery$data;
  variables: AssetAllocationDetailQueryReaderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetAllocationFilterInput"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetAllocationInput"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "balancesInput"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "financialAccountId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "managementStyle",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserProfileViewer",
    "kind": "LinkedField",
    "name": "userprofile_viewer",
    "plural": false,
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "UserAccount",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountNickname",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountGroup",
        "kind": "LinkedField",
        "name": "accountGroups",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "accounts",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ClientSummaryViewer",
    "kind": "LinkedField",
    "name": "clientsummary_viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "assetAllocationInput"
          },
          {
            "kind": "Variable",
            "name": "where",
            "variableName": "assetAllocationFilterInput"
          }
        ],
        "concreteType": "GetAssetAllocationModel",
        "kind": "LinkedField",
        "name": "getAssetAllocations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "allocationId",
            "storageKey": null
          },
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountDefaultName",
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "assetClassBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subAssetClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subAssetClassBalance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "asOfDate",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FinancialAccount",
        "kind": "LinkedField",
        "name": "financialAccounts",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientIdentifier",
            "storageKey": null
          },
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registrationName",
            "storageKey": null
          },
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountTypeAbbreviation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "custodian",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "balancesInput"
          }
        ],
        "concreteType": "AccountBalancesModel",
        "kind": "LinkedField",
        "name": "getAccountBalances",
        "plural": true,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalBalance",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetAllocationDetailQueryReaderQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssetAllocationDetailQueryReaderQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "518d2b206156708de3023c8f2dc24db3",
    "id": null,
    "metadata": {},
    "name": "AssetAllocationDetailQueryReaderQuery",
    "operationKind": "query",
    "text": "query AssetAllocationDetailQueryReaderQuery(\n  $assetAllocationInput: GetAssetAllocationInput!\n  $assetAllocationFilterInput: GetAssetAllocationModelFilterInput\n  $balancesInput: GetAccountBalancesInput!\n) {\n  userprofile_viewer {\n    id\n    accounts {\n      accountNickname\n      financialAccountId\n    }\n    accountGroups {\n      id\n      name\n      accounts {\n        id\n        financialAccountId\n      }\n    }\n  }\n  clientsummary_viewer {\n    getAssetAllocations(input: $assetAllocationInput, where: $assetAllocationFilterInput) {\n      allocationId\n      accountId\n      accountDefaultName\n      accountNumber\n      managementStyle\n      accountBalance\n      assetClass\n      assetClassBalance\n      subAssetClass\n      subAssetClassBalance\n      asOfDate\n    }\n    financialAccounts {\n      id\n      accountName\n      clientIdentifier\n      accountNumber\n      registrationName\n      managementStyle\n      accountType\n      accountTypeAbbreviation\n      custodian\n    }\n    id\n    getAccountBalances(input: $balancesInput) {\n      accountId\n      totalBalance\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e50fe3873b2cacdf7389efc04cb61b53";

export default node;
